import axios from 'axios';

const ROOT = '/api/v1/users';

export const UserCustomViewApi = {
  getAllUserCustomViews(userId, tableName) {
    return axios.get(`${ROOT}/${userId}/views/${tableName}`);
  },
  createCustomView(userId, userCustomViewRequest) {
    return axios.post(`${ROOT}/${userId}/views`, userCustomViewRequest);
  },
  deleteCustomView(userId, viewId, pageKey) {
    return axios.delete(`${ROOT}/${userId}/views/${viewId}`, {
      params: { pageKey }
    });
  },
  activateCustomView(userId, viewId, pageKey) {
    return axios.put(`${ROOT}/${userId}/views/${viewId}/activate`, null, {
      params: { pageKey }
    });
  },
  logViewApplyError(userId, viewId, tableName, errorLog) {
    return axios.post(`${ROOT}/${userId}/views/${tableName}/${viewId}/error`, errorLog);
  },
  updateCustomViews(userId, tableName, userCustomViewsRequest) {
    return axios.put(`${ROOT}/${userId}/views/${tableName}`, userCustomViewsRequest);
  }
};
